"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var SvgHotelQuantity = function SvgHotelQuantity(_ref) {
  var _ref$rectY = _ref.rectY,
      rectY = _ref$rectY === void 0 ? '100%' : _ref$rectY,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#17181A' : _ref$fill,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? '17181A' : _ref$stroke,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["rectY", "fill", "stroke"]);
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#a"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M1 3.89V4a.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5v6.5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V11a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v.5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5v-.11a.61.61 0 0 0-.354-.554L7.919.693a1 1 0 0 0-.838 0L1.354 3.336A.61.61 0 0 0 1 3.89z",
    stroke: stroke
  }), /*#__PURE__*/React.createElement("g", {
    fill: fill,
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0%",
    y: rectY,
    rx: 0,
    ry: 0,
    width: "100%",
    height: "100%"
  })));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgHotelQuantity);
var _default = Memo;
exports["default"] = _default;